export default __webpack_public_path__ + "static/media/main_banner.89fbfe12.jpg";